module.exports = __webpack_public_path__ + "static/img/Bachelor_010689.3f3f398.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010689.jpg
// module id = 215
// module chunks = 0